<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="주문 내역 조회"
      desc="전체 주문내역을 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props">
        <div @click.stop.prevent="clickEst(props.item)" class="unselect">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="bid_content" slot-scope="props">
        <div @click.stop.prevent="clickOrder(props.item)" class="unselect">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="order_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.status === 0">주문 대기</div>
        <div v-if="props.item.status === 1">주문 승인</div>
        <div v-if="props.item.status === 2">주문 확정</div>
        <div v-if="props.item.status === 101">주문 거절</div>
        <div v-if="props.item.status === 102">주문 취소</div>
      </div>

      <div slot="status" slot-scope="props" style="width: 120px; margin: auto;">
        <!--<button v-if="props.item.status=== 0"
                class="button state-btn ests-btn-accept-order"
                @click="openPopUp(props.item.id, 'accept')"
                >주문 승인</button>
        <button v-if="props.item.status=== 0"
                class="button state-btn ests-btn-deny-order"
                style="margin-top:8px"
                @click="openPopUp(props.item.id, 'deny')"
                >주문 거절</button>-->
        <button v-if="props.item.status===1"
                class="button"
                @click="openPopUp(props.item.id, 'success')">주문 확정</button>
        <button v-else-if="props.item.status===0"
                class="button"
                style="margin-top:8px"
                @click="openPopUp(props.item.id, 'cancel')">주문 취소</button>
        <span v-else>-</span>
      </div>
    </admin-table>

    <modal name="openModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="modalItem">
        <div>{{ modalItem.id }}번 {{ modalItem.text }}</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('openModal')">취소</button>
          <button class="button is-primary" @click="cancelOrder">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'OrderAll',
    mixins: [
      ListMixin
    ],

    created() {
      this.init();
    },

    computed: {
      partnerName(){
        let partner = find(this.partners, 'value', this.selectedItem.partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },

    data () {
      return {
        selectedItem: undefined,    // 팝업으로 표시할 선택된 아이템
        partners: [],
        modalItem: undefined,
      }
    },
    methods: {
      init() {
        this.initializing('order_all', 'estimate/order');
        if(this.$store.getters.mode==='admin') {
          this.$axios.get('admin/partner/simple').then(res => {
            this.partners = res.data;
          })
        }
      },
      getDataFromServer() {
        this.getData();
      },
      openPopUp (id, type) {
        if(type==='cancel') {
          this.modalItem = {
            id: id,
            text: '주문을 취소하시겠습니까?',
            type: type
          }
        }
        else if(type==='deny') {
          this.modalItem = {
            id: id,
            text: '주문을 거절하시겠습니까?',
            type: type
          }
        }
        else if(type==='accept') {
          this.modalItem = {
            id: id,
            text: '주문을 승인하시겠습니까?',
            type: type
          }
        }
        else if(type==='success') {
          this.modalItem = {
            id: id,
            text: '주문을 확정하시겠습니까?',
            type: type
          }
        }
        this.$modal.show('openModal');
      },
      // 주문 승인, 거절 요청
      checkStatus(item, type){
        if(type==='accept') {
          this.$axios.post(this.getUrl('estimate/order/' + item.id + '/accept'), {
            status: 1
          }).then(res => {
            if (res.status === 200) {
              item.status = 1;
            }
          });
        }
        else if(type==='deny') {
          this.$axios.post(this.getUrl('estimate/order/' + item.id + '/deny'), {
            status: 101
          }).then(res => {
            if (res.status === 200) {
              item.status = 101;
            }
          });
        }
      },
      cancelOrder () {
        let url = '';
        let toast_msg = '';
        if(this.modalItem.type==='cancel') {
          url = `estimate/order/${this.modalItem.id}/cancel`;
          toast_msg = '취소 완료되었습니다.';
        }
        else if(this.modalItem.type==='deny') {
          url = `estimate/order/${this.modalItem.id}/deny`;
          toast_msg = '거부 완료되었습니다.';
        }
        else if(this.modalItem.type==='accept') {
          url = `estimate/order/${this.modalItem.id}/accept`;
          toast_msg = '승인 완료되었습니다.';
        }
        else if(this.modalItem.type==='success') {
          url = `estimate/order/${this.modalItem.id}/success`;
          toast_msg = '확정 완료되었습니다.';
        }
        this.$axios.post(this.getUrl(url))
          .then(res => {
            if(res.status===200) {
              this.toast(toast_msg);
              this.$modal.hide('openModal');
              this.getData();
            }
          })
      },

      // 견적요청서 보기
      clickEst(item) {
        this.$axios.get(this.getUrl('estimate/request/'+item.request_id))
        .then(res=>{
          if(res.status===200){
            //this.$refs.estModal.open();
            this.selectedItem = {
              name: item.name,
              email: item.email,
              created_time: item.created_time,
              phone: item.phone,
              steps: res.data.steps
            }

            let value = {
              selectedItem: this.selectedItem
            }
            this.$store.commit('openModal', {type:'modal-order-content', value: value});
          }
        })
      },

      clickOrder(item) {
        this.$axios.get(this.getUrl('estimate/bid/'+item.bid_id))
          .then(res=> {
            if(res.status===200) {
              let value = res.data;
              value.name = item.name;
              value.email = item.email;
              value.phone = item.phone;
              this.$store.commit('openModal', {type:'modal-bid-content', value: value})
            }
          })
      },

      // 견적 상태 - 신규요청확인 클릭
      chkReq(item) {
        this.$axios.post(this.getUrl('estimate/request/'+item.id+'/waiting')).then(res => {
          if(res.status===200){
            item.status = 1;
          }
        });
      },

      //견적서 보기
      clickBid(item, bid) {
        this.selectedItem = {
          bid_info: item.bid_info,
          request_id: item.id,
          price: bid.price,
          note: bid.note,
          price_info: bid.price_info,
          user: bid.user,
          created_time: bid.created_time
        };
        setTimeout(res => {
          this.$refs.bidModal.open();
        }, 100);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-done
    background-color #d5514b
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0

  .btn-cancel-by-ests
    color $negative

  .lp-background-red
    background-color $negative
    color white

  .modal-step
    padding 4px
    margin-top 12px

</style>
